import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'vnm-email-address',
  templateUrl: './email-address.component.html',
  styleUrls: ['./email-address.component.scss']
})
export class EmailAddressComponent implements OnChanges {
  @Input() email: string;
  @Input() showIcon = true;
  @Input() enableLink = true;

  emailHref: string = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.email || changes.enableLink) {
      this.emailHref = this.enableLink ? `mailto:${this.email}` : null;
    }
  }
}
